import React, {useEffect} from 'react';
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { useState } from "react"
import Spinner from './Spinner'
import {gql, useLazyQuery, useQuery} from '@apollo/client'
import { useHistory } from 'react-router-dom'
import moment from 'moment';

import {useCsEvent} from '../client/useEvents'

const yillarQuery = gql`
  query Gazete($gazete: String!) {
    gazete(gazete: $gazete) {
      yillar, 
    }
  }
`
const gunlerQuery = gql`
  query Gazete($gazete: String!, $yil: Int!) {
    gazete(gazete: $gazete) {
      gunler(yil: $yil)
    }
  }
`
const Component = (props) => {
  const { gazete } = props
  const history = useHistory()
  const [sonYil, setSonYil] = useState(0)
  const [sayilar, setSayilar] = useState({})
  const [startDate, setStartDate] = useState<Date|null>(null)
  const fireCsEvent = useCsEvent()
  const { data: yillarData, loading: yillarLoading, error: yillarError } = useQuery(yillarQuery, {
    variables: { gazete },
  })
  const [loadGunler, { data: gunlerData, loading: gunlerLoading, error: gunlerError }] = useLazyQuery(gunlerQuery, {
    variables: { gazete, yil: 0 }, 
    notifyOnNetworkStatusChange: true,
  })

  useEffect(() => {
    if (!yillarLoading && yillarData) {
      console.debug("Yıllar data loaded:", yillarData)
      setSonYil(yillarData.gazete.yillar[0])
      loadGunler({ variables: { gazete, yil: yillarData.gazete.yillar[0] } })
    }
  }, [yillarLoading, gazete, loadGunler, yillarData])
  useEffect(() => {
    if (!gunlerData) return
    const ilkGunDate = new Date(gunlerData.gazete.gunler[0])
    const ilkGunDateOffset = new Date(ilkGunDate.getTime()+ilkGunDate.getTimezoneOffset()*60000)

    if (!gunlerLoading && ilkGunDateOffset.getFullYear() === sonYil) {
      console.debug("Gunler data loaded:", sonYil, gunlerData)
      sayilar[sonYil] = gunlerData.gazete.gunler
      if (startDate === null) {
        const gun = new Date(gunlerData.gazete.gunler[0])
        setStartDate(new Date(gun.getTime()+gun.getTimezoneOffset()*60000))
      }
    }
  }, [gunlerLoading, sonYil, gunlerData, sayilar, startDate])
  return (
    <div className="">
      {(yillarLoading || gunlerLoading) && 
        <div className='d-flex' style={{justifyContent: 'center'}}>
          <Spinner />
        </div>}
      {!yillarLoading && startDate && <div style={{display: 'flex', justifyContent: 'center'}}><DatePicker
        id="gazetesayisipicker"
        inline={true}
        minDate={new Date(yillarData.gazete.yillar[0], 0, 1)}
        maxDate={new Date(yillarData.gazete.yillar[yillarData.gazete.yillar.length - 1], 11, 31)}
        showYearDropdown={true}
        dropdownMode="select"
        selected={startDate}
        disabled={yillarLoading || gunlerLoading}
        onChange={(date: Date|null) => {
          if (!date) return
          fireCsEvent({
            category: "Gazete",
            action: "Navigation",
            label: "Takvimden tarih seçildi"
          })
          setStartDate(date)
          history.push(`/gazete/${gazete}/${moment(date).format('YYYY-MM-DD')}/1`)
        }}
        onYearChange={(date: Date) => {
          console.debug("Year changed:", date)
          if (!sayilar[date.getFullYear()]) {
            loadGunler({ variables: { gazete, yil: date.getFullYear() } })
          }
          setSonYil(date.getFullYear())
        }}
        onMonthChange={(date: Date) => {
          console.debug("Month changed:", date)
          if (!sayilar[date.getFullYear()]) {
            loadGunler({ variables: { gazete, yil: date.getFullYear() } })
          }
          setSonYil(date.getFullYear())
        }}
        filterDate={(date: Date) => {
          const gunler: string[] = sayilar[date.getFullYear()]
          {/*console.debug("Filtering date:", date, gunler)*/}
          if (gunler) {
            return gunler.some((gun: string) => {
              let gunDate = new Date(gun)
              let offsetDate = new Date(gunDate.getTime()+gunDate.getTimezoneOffset()*60000)
              return offsetDate.getDate() === date.getDate() 
                && offsetDate.getMonth() === date.getMonth()
            })
          }
          return false
        }}
        className="border border-gray-300 rounded-md p-2"
      /></div>}
    </div>
  )
}

export default Component
